export default __webpack_public_path__ + "static/media/betaabvalley.159da04e.jpg";